import { render, staticRenderFns } from "./CargoVehicleDeparturesPage.vue?vue&type=template&id=3814a442"
import script from "./CargoVehicleDeparturesPage.vue?vue&type=script&lang=js"
export * from "./CargoVehicleDeparturesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports